<template>
    <div>
        <UserBulkInviteModal :close-modal="toggleBulkInviteModal" />
        <div class="flex flex-wrap items-center justify-between items-center pv4 w-90 center">
            <div>
                <div class="pb3 pb0-l f5 b lh-copy">Business Invites</div>
            </div>
            <div>
                <button class="btn3 mr3 mb0-l mb3" @click.prevent="toggleBulkInviteModal">Bulk Invite</button>
                <button class="btn3 mr3 mb0-l mb3" @click.prevent="refreshPage">Refresh</button>
            </div>
        </div>

        <div class="scrollmenu w-90 center pt2">
            <table class="w-100 tl pt3 bt b--black-20" cellspacing="0">
                <thead>
                    <tr>
                        <th class="pb3 bb b--black-20 pr3 tl lh-title">Name</th>
                        <th class="pb3 bb b--black-20 pr3 tl lh-title">Email</th>
                        <th class="pb3 bb b--black-20 pr3 tl lh-title">Phone</th>
                        <th class="pb3 bb b--black-20 pr3 tl lh-title">Created</th>
                        <th class="pb3 bb b--black-20 pr3 tl lh-title">Status</th>
                        <!-- <th class="pb3 bb b--black-10 pr3 tl lh-title"></th> -->
                    </tr>
                </thead>
                <tbody v-if="invites.length">
                    <tr v-for="user in invites" :key="user._id" class="font-w1">
                        <td class="pv3 pr3 bb b--black-20 tl">{{ user.firstName }} {{ user.lastName }}</td>
                        <td class="pv3 pr3 bb b--black-20 tl">{{ user.email }}</td>
                        <td class="pv3 pr3 bb b--black-20 tl">{{ user.phone }}</td>
                        <td class="pv3 pr3 bb b--black-20 tl">{{ formatDate(user.createdAt) }}</td>
                        <td class="pv3 pr3 bb b--black-20 tl">
                            <span v-if="user.pending" class="badge badge-danger">Pending</span>
                            <span v-else class="badge badge-success">Onboarded</span>
                        </td>
                        <!-- <td class="pv3 pr3 bb b--black-10 tl">Remove</td> -->
                    </tr>
                </tbody>
                <tbody v-else>
                    <tr>
                        <td colspan="5">
                            <TableEmptyState 
                                :data-array="invites" 
                                message="No business invites" 
                            />
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div v-if="invites.length">
            <Pagination
                class="mt3"
                :limit="$route.query.limit"
                :pages="invites?.pagination"
                route-name="Admin Setting"
                :onNavigate="onNavigate"
            />
        </div>
    </div>
</template>

<script>
import { ref } from '@vue/reactivity'
import AdminWrapper from '../../../layout/AdminWrapper.vue'
import { useStore } from 'vuex'
import { computed, onMounted } from '@vue/runtime-core'
import { useRoute } from 'vue-router'
import Pagination from '@/components/Pagination'
import UserBulkInviteModal from '@/views/Admin/Setting/widgets/UserBulkInviteModal'
import TableEmptyState from '@/components/TableEmptyState'

import Spinner from '@/components/Spinner'
import { formatDate, formatDateFilter } from '@/utils/lib'
export default {
    components: {
        AdminWrapper,
        Pagination,
        UserBulkInviteModal,
        Spinner,
        TableEmptyState
    },
    setup() {
        const store = useStore()
        const route = useRoute()
        const start = ref(formatDateFilter(new Date(new Date().setFullYear(new Date().getFullYear() - 23))))
        const end = ref(formatDateFilter(new Date()))
        const query = ref({
            start: start.value,
            end: end.value,
            limit: route.query.limit || 10,
            page: route.query.page || 1
        })
        const invites = computed(() => store.state.Admin.businessInvites)

        const toggleBulkInviteModal = () => {
            store.dispatch('Admin/toggleBulkInviteModal')
        }

        const onNavigate = query => {
            store.dispatch('Admin/getBusinessInvites', query)
        }

        const getBusinessInvites = () => {
            store.dispatch('Admin/getBusinessInvites', {
                filterType: 'adminRange',
                start: '2020-01-01',
                end: formatDateFilter(new Date()),
                limit: route.query.limit || 10,
                page: route.query.page || 1
            })
        }

        const refreshPage = () => {
            getBusinessInvites()
        }

        onMounted(() => {
            getBusinessInvites()
        })

        return {
            query,
            invites,
            onNavigate,
            formatDate,
            toggleBulkInviteModal,
            refreshPage
        }
    }
}
</script>

<style scoped>
.makeCursorPointer {
    cursor: pointer;
}

.dGrid {
    display: grid;
}

.cardwidth {
    width: 30rem;
}

.gridCol3 {
    grid-template-columns: repeat(3, minmax(0, 1fr));
}

@media screen and (max-width: 750px) {
    .gridCol3 {
        grid-template-columns: repeat(1, minmax(0, 1fr));
    }

    .cardwidth {
        width: 100%;
    }
}
</style>
